import { CloudSDK } from '@sitecore-cloudsdk/core/server';
import '@sitecore-cloudsdk/events/server';
import '@sitecore-cloudsdk/search/server';

type CloudSdkServerSettings = {
  sitecoreEdgeContextId: string;
  siteName: string;
};

let initPromise: Promise<void> | null = null;

/**
 * Cloud Search server APIs require global SDK settings. Call once per Node process before getWidgetData.
 */
export function ensureCloudSdkServerForSearch(settings: CloudSdkServerSettings): Promise<void> {
  if (!settings.sitecoreEdgeContextId?.trim() || !settings.siteName?.trim()) {
    return Promise.resolve();
  }

  if (!initPromise) {
    // Search server APIs only need edge settings; request/response are unused when enableServerCookie is false.
    initPromise = CloudSDK(
      undefined as unknown as Parameters<typeof CloudSDK>[0],
      undefined as unknown as Parameters<typeof CloudSDK>[1],
      {
        sitecoreEdgeContextId: settings.sitecoreEdgeContextId,
        siteName: settings.siteName,
        enableServerCookie: false,
      }
    )
      .addEvents()
      .addSearch()
      .initialize();
  }

  return initPromise;
}
